import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "./Login.css";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Paper,
  Typography,
  TextField,
  Button,
  Alert,
  Stack,
} from "@mui/material";
import api from "../api";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const json = await api.login(username, password);

      if (!json.access_token) {
        setError("Invalid username or password");
        setLoading(false);
        return;
      }

      setError("");

      // notify same-tab listeners too
      window.dispatchEvent(new Event("auth-changed"));

      navigate("/plc");
    } catch (err) {
      setError(err.message || "Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Navbar />

      <Box className="login-page-shell">
        <Paper className="login-card" elevation={0}>
          <Stack spacing={1.5} sx={{ mb: 3 }}>
            <Typography variant="h4" className="login-title">
              Welcome back
            </Typography>
            <Typography variant="body1" className="login-subtitle">
              Sign in to view PLC dashboards and machine data.
            </Typography>
          </Stack>

          <Box component="form" className="login-form" onSubmit={handleSubmit}>
            {error && (
              <Alert severity="error" sx={{ mb: 2, borderRadius: 3 }}>
                {error}
              </Alert>
            )}

            <TextField
              label="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              fullWidth
              autoComplete="username"
            />

            <TextField
              label="Password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              fullWidth
              autoComplete="current-password"
            />

            <Button
              type="submit"
              variant="contained"
              size="large"
              disabled={loading}
              sx={{ mt: 1.5 }}
            >
              {loading ? "Signing in..." : "Sign In"}
            </Button>
          </Box>
        </Paper>
      </Box>

      <Footer />
    </>
  );
};

export default Login;